import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'src/design/atoms/NavLink';
import { Stack } from 'src/design/atoms/Stack';
import { IconUserFilled, IconLogout } from '@tabler/icons-react';

export interface IProfileTabProps {
  handleLogout: () => void;
}

/** @registry Profile popover's tab content: view-profile and logout nav links. */
export const ProfileTab: React.FC<IProfileTabProps> = ({ handleLogout }) => {
  const navigate = useNavigate();

  return (
    <Stack gap={0}>
      <NavLink
        label="View Profile"
        leftSection={<IconUserFilled color="grey" size={20} />}
        onClick={() => navigate('/account/profile')}
      />
      <NavLink
        label="Logout"
        leftSection={<IconLogout color="grey" size={20} />}
        onClick={handleLogout}
      />
    </Stack>
  );
};
